// External modules
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { DateOfBirth as DateOfBirthInput } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';

export type DateOfBirthProps = {
  blurHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const DateOfBirth = (props: DateOfBirthProps): JSX.Element => {
  useMountLogging('DateOfBirth');
  const dateOfBirth = useStoreState(({ form }) => form.dateOfBirth);
  const { displayFormat, datePattern } = useStoreState(({ api }) => {
    return api.griffinMetadata.dateMeta;
  });

  return (
    <DateOfBirthInput
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      containerStyleOverrides={{ marginBottom: '12px' }}
      dateFormat={displayFormat}
      datePattern={datePattern}
      focusHandler={props.focusHandler}
      id="dateOfBirth"
      label={getContent('fieldLabels.dob')}
      required={true}
      type="tel"
      {...dateOfBirth}
    />
  );
};

export { DateOfBirth };
